<template>
    <div class="card-panel">
        <div class="card-body">
            <h4> Easy Diagnostic </h4>
            <div class="line-header"></div>
            
            <div class="form-group">
                <p>WAN IP Check</p>
                <div class="row">
                    <div class="col-xs-10">
                        <div class="progress progress-striped active small no-margin">
                            <div class="progress-bar" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" 
                            :style="'width: ' + (wan.check ? '100%' : '0%')">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-2 text-center">
                        <img v-if="wan.check" src="@/assets/img/home/Path_231.png">
                        <img v-else src="@/assets/img/home/ico_home_no.png">
                    </div>
                </div>
                <span class="text-gray label-below">WAN IP Address :{{wan.ip}}</span>
            </div>
            <div class="form-group">
                <p>DNS Check</p>
                <div class="row">
                    <div class="col-xs-10">
                        <div class="progress progress-striped active small no-margin">
                            <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" 
                            :style="'width: ' + (wanDnsCheck ? '100%' : '0%')">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-2 text-center">
                        <img v-if="wanDnsCheck" src="@/assets/img/home/Path_231.png">
                        <img v-else src="@/assets/img/home/ico_home_no.png">
                    </div>
                </div>
                <span class="text-gray label-below">DNS1 IP Address : {{wan.dns1}}</span>
                <span class="text-gray label-below">DNS2 IP Address : {{wan.dns2}}</span>
            </div>
            <div class="form-group">
                <p>Ping Check</p>
                <div class="row">
                    <div class="col-xs-10">
                        <div class="progress progress-striped active small no-margin">
                            <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"
                            :style="'width: ' + (wan.pingCheck ? '100%' : '0%')">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-2 text-center">
                        <img v-if="wan.pingCheck" src="@/assets/img/home/Path_231.png">
                        <img v-else src="@/assets/img/home/ico_home_no.png">
                    </div>
                </div>
                <span class="text-gray label-below">Ping IP Address : {{wan.gateway}}</span>
            </div>
            <!-- SR120A 4口设备 -->
            <div v-if="$G_DEVICE_CFG.lanNum === 4">
            <div class="form-group">
                <p>LAN1 IP Check</p>
                <div class="row">
                    <div class="col-xs-10">
                        <div class="progress progress-striped active small no-margin">
                            <div class="progress-bar" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" 
                            :style="'width: ' + (lan[0].check ? '100%' : '0%')">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-2 text-center">
                        <img v-if="lan[0].check" src="@/assets/img/home/Path_231.png">
                        <img v-else src="@/assets/img/home/ico_home_no.png">
                    </div>
                </div>
                <span class="text-gray label-below" v-for="_ip in lan[0].ip" :key="_ip">LAN1 IP Address : {{_ip}}</span>
            </div>
            <div class="form-group">
                <p>LAN2 IP Check</p>
                <div class="row">
                    <div class="col-xs-10">
                        <div class="progress progress-striped active small no-margin">
                            <div class="progress-bar" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" 
                            :style="'width: ' + (lan[1].check ? '100%' : '0%')">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-2 text-center">
                        <img v-if="lan[1].check" src="@/assets/img/home/Path_231.png">
                        <img v-else src="@/assets/img/home/ico_home_no.png">
                    </div>
                </div>
                <span class="text-gray label-below" v-for="_ip in lan[1].ip" :key="_ip">LAN2 IP Address : {{_ip}}</span>
            </div>
            <div class="form-group">
                <p>LAN3 IP Check</p>
                <div class="row">
                    <div class="col-xs-10">
                        <div class="progress progress-striped active small no-margin">
                            <div class="progress-bar" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" 
                            :style="'width: ' + (lan[2].check ? '100%' : '0%')">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-2 text-center">
                        <img v-if="lan[2].check" src="@/assets/img/home/Path_231.png">
                        <img v-else src="@/assets/img/home/ico_home_no.png">
                    </div>
                </div>
                <span class="text-gray label-below" v-for="_ip in lan[2].ip" :key="_ip">LAN3 IP Address : {{_ip}}</span>
            </div>
            <div class="form-group">
                <p>LAN4 IP Check</p>
                <div class="row">
                    <div class="col-xs-10">
                        <div class="progress progress-striped active small no-margin">
                            <div class="progress-bar" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" 
                            :style="'width: ' + (lan[3].check ? '100%' : '0%')">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-2 text-center">
                        <img v-if="lan[3].check" src="@/assets/img/home/Path_231.png">
                        <img v-else src="@/assets/img/home/ico_home_no.png">
                    </div>
                </div>
                <span class="text-gray label-below"  v-for="_ip in lan[3].ip" :key="_ip">LAN4 IP Address : {{_ip}}</span>
            </div>
            </div>
            <!-- SR120C 2口设备 -->
            <div v-else>
                <div class="form-group">
                <p>LAN1 IP Check</p>
                <div class="row">
                    <div class="col-xs-10">
                        <div class="progress progress-striped active small no-margin">
                            <div class="progress-bar" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" 
                            :style="'width: ' + (lan[2].check ? '100%' : '0%')">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-2 text-center">
                        <img v-if="lan[2].check" src="@/assets/img/home/Path_231.png">
                        <img v-else src="@/assets/img/home/ico_home_no.png">
                    </div>
                </div>
                <span class="text-gray label-below" v-for="_ip in lan[2].ip" :key="_ip">LAN1 IP Address : {{_ip}}</span>
            </div>
            <div class="form-group">
                <p>LAN2 IP Check</p>
                <div class="row">
                    <div class="col-xs-10">
                        <div class="progress progress-striped active small no-margin">
                            <div class="progress-bar" role="progressbar" aria-valuenow="45" aria-valuemin="0" aria-valuemax="100" 
                            :style="'width: ' + (lan[3].check ? '100%' : '0%')">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-2 text-center">
                        <img v-if="lan[3].check" src="@/assets/img/home/Path_231.png">
                        <img v-else src="@/assets/img/home/ico_home_no.png">
                    </div>
                </div>
                <span class="text-gray label-below"  v-for="_ip in lan[3].ip" :key="_ip">LAN2 IP Address : {{_ip}}</span>
            </div>
            </div>
        </div>
        <div class="card-footer border-top home-btn">
            <el-button  :loading="isLoad" @click="connect">Re-Connect</el-button>
        </div>
    </div>
</template>

<script>
import devConfig from '@/devConfig'
export default {
    data() {
        return {
            isLoad:false,
            isBridge:false,
            wan: {
                check:false,
                ip:"",
                gateway:"",
                dns1:"",
                dns2:"",
                pingCheck:false
            },
            lan:[
                {
                    check:false,
                    ip:[]
                },
                {
                    check:false,
                    ip:[]
                },
                {
                    check:false,
                    ip:[]
                },
                {
                    check:false,
                    ip:[]
                }
            ]
        }
    },
    computed: {
        wanDnsCheck() {
            let dnsCheck = false;
            if(this.wan.dns1 != "" && this.wan.dns1 !== "0.0.0.0")
                dnsCheck = true

            if(this.wan.dns2 != "" && this.wan.dns2 !== "0.0.0.0")
                dnsCheck = true
            return dnsCheck
        }
    },
    created(){
        devConfig.init(this,()=>{
            this.isBridge = devConfig.getData().isBridge
            this.connect()
        })
        
    },
    methods:{
        initData(){
            this.load = false
            this.progress = 0
            this.wan = {
                check:false,
                ip:"",
                gateway:"",
                dns1:"",
                dns2:"",
                pingCheck:false
            }
            this.lan = [
                {
                    check:false,
                    ip:[]
                },
                {
                    check:false,
                    ip:[]
                },
                {
                    check:false,
                    ip:[]
                },
                {
                    check:false,
                    ip:[]
                }
            ]
        },
        getData(){
            
            this.isLoad = true
            axios
            .post("/boafrm/fhEasyDiagnostic")
            .then((response)=>{
                let _data = response.data
                let _this = this
                if(_data.wanIndex != 0 && _data.wanConnect)
                {
                    this.wan.check = true
                    this.wan.ip = _data.wanIp
                    this.wan.gateway = _data.wanGateway
                    this.wan.dns1 = _data.wanDns1
                    this.wan.dns2 = _data.wanDns2
                    this.wan.pingCheck = _data.pingCheck
                }
                if(!this.isBridge)
                {// 桥模式不显示LAN侧IP地址
                    for (let index = 0; index < _this.lan.length; index++) {
                        _this.lan[index].check = _data.lanStatus[index]
                        if(_data.lanStatus[index])
                        {
                            _data.lanDevices.forEach(element => {
                                if(element.lanPort == index)
                                {
                                    _this.lan[index].ip.push(element.ip)
                                }
                            });
                        }
                    }
                }
                
                this.isLoad = false
            })

           
        },
        connect(){
            /*每次获取数据 需要重置*/
            this.initData()

            
            setTimeout(()=>{
                this.getData()
            },1000)
        }

    }
}
</script>

